import { useState } from 'react';
import './App.css';
import { ReactFitty } from "react-fitty";
import { Helmet } from 'react-helmet';

import ReactGA from 'react-ga4';
const TRACKING_ID = "G-XVJYE5NMJ4";
ReactGA.initialize(TRACKING_ID);

function rot13(str) {
  var input     = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  var output    = 'NOPQRSTUVWXYZABCDEFGHIJKLMnopqrstuvwxyzabcdefghijklm';
  var index     = x => input.indexOf(x);
  var translate = x => index(x) > -1 ? output[index(x)] : x;
  return str.split('').map(translate).join('');
}

function App() {
  const queryParameters = new URLSearchParams(window.location.search)
  const type = queryParameters.get("h")
  const name = queryParameters.get("t")

  const [quiValue, setQuiValue] = useState("");
  const [quoiValue, setQuoiValue] = useState("");

  const onChangeHandler = (name, event) => {
    if (name === "qui") setQuiValue(event.target.value);
    else setQuoiValue(event.target.value);
  };

  const relocate = (event, qui, quoi) => {
    event.preventDefault()
    window.location.href='/?h='+rot13(qui)+'&t='+rot13(quoi)
  }

  if (type && name) {
    ReactGA.event({
      category: 'Click',
      action: 'Created a name',
      label: `Regarde ${rot13(type)} ${rot13(name)}`
    });
  }

  const title = (type && name)
  ? `Regarde ${rot13(type)} ${rot13(name)}`
  : 'Regarde les hommes tomber'

  return (
    <>
    <Helmet>
      <title>{ title }</title>
    </Helmet>
    {/* <div id="noise" /> */}
    <div id="overlay" />
    <div id="overlay2" />
    <div className="App">
      <div className="content">
        <ReactFitty>
          <span id="title1" className='text'>regarde</span>
        </ReactFitty>
        {type && name ?
          <>
            <ReactFitty>
              <span id="title2" className='text'>{rot13(type)}</span>
            </ReactFitty>
            <ReactFitty>
              <span id="title3" className='text'>{rot13(name)}</span>
            </ReactFitty>
            <div id="reset">
              <a href="/">Recommencer</a>
            </div>
          </>
          : 
          <form className="form" onSubmit={(event) => relocate(event, quiValue, quoiValue)}>
            <input 
              name="qui"
              type="text" 
              value={quiValue}
              className="textInput" 
              placeholder="Qui?" 
              onChange={(event) => onChangeHandler("qui", event)} 
            />
            <input 
              name="quoi"
              type="text" 
              value={quoiValue}
              className="textInput" 
              placeholder="Quoi?"
              onChange={(event) => onChangeHandler("quoi", event)} 
            />
            <input 
              type="submit" 
              className="submit" 
              value="Ok" 
              disabled={!quiValue || !quoiValue}
              onClick={(event) => relocate(event, quiValue, quoiValue)} 
            />
          </form>
        }
      </div>
    </div>
    </>
  );
}

export default App;
